import { CenterStaffFilters } from "./types";

export const DefaultCenterStaffFilters: CenterStaffFilters = {
  isRehireable: undefined,
  position: undefined,
  isActive: undefined
};
